const BASE_URL = 'https://ottotuhkunen.github.io/virtual-lara-airspace-data';

export function getGeojsonFile(locationKey) {
  return `${BASE_URL}/data/${locationKey}.geojson`;
}

export function getJsonFile(locationKey) {
  return `${BASE_URL}/data/${locationKey}.json`;
}

// ----- AREA CONFIG LIST -----
export const areas = [
    { value: 'efin', country: 'Finland', label: 'EFINZAMC | Finland', home: true },
    { value: 'ebbu', country: 'Belgium', label: 'EBBUZAMC | Belgium' },
    { value: 'ekdk', country: 'Denmark', label: 'EKDKZAMC | Denmark'},
    { value: 'lfxx', country: 'France', label: 'LFXXZAMC | France' },
    { value: 'edxx', country: 'Germany', label: 'EDXXZAMC | Germany' },
    { value: 'egxx', country: 'United Kingdom', label: 'EGXXZAMC | United Kingdom' },
    { value: 'eett', country: 'Estonia', label: 'EETTZAMC | Estonia' },
    { value: 'eisn', country: 'Ireland', label: 'EISNZAMC | Ireland'},
    { value: 'llll', country: 'Israel', label: 'LLLLZAMC | Israel'},
    { value: 'enor', country: 'Norway', label: 'ENORZAMC | Norway'},
    { value: 'esaa', country: 'Sweden', label: 'ESAAZAMC | Sweden' },
    { value: 'omae', country: 'United Arab Emirates', label: 'OMAEZAMC | Emirates' },
    { value: 'orbb', country: 'Iraq', label: 'ORBBZAMC | Iraq' },
    { value: 'okac', country: 'Kuwait', label: 'OKACZAMC | Kuwait' },
    { value: 'rphi', country: 'Philippines', label: 'RPHIZAMC | Philippines'},
    { value: 'eacc', label: 'EACCZAMC | Amswell', chip: { label: 'Test environment', className: 'testenvironment' } },
];
// chip: { label: 'Pre-operational', className: 'preoperational'

// ----- AGENCY CONFIG LIST -----
export const agencies = [
  { value: 'Civil', label: 'CIVIL' },
  { value: 'Military', label: 'MILITARY' },
  { value: 'vNATO', label: 'Virtual NATO' },
  { value: 'vGAF', label: 'Virtual German Air Force' },
  { value: 'vRAF', label: 'Virtual Royal Air Force' },
  { value: 'MODv', label: 'Ministry of Defence Virtual' },
  { value: 'vHelimed', label: 'Virtual Helimed' },
  { value: 'vFiAF', label: 'Virtual Finnish Air Force' },
  { value: 'BVASO', label: 'BVA Spec Ops' },
  { value: 'vUSAF', label: 'Virtual United States Air Force' },
  { value: 'vRNLAF', label: 'Virtual Royal Netherlands Air Force' },
  { value: 'vSwAF', label: 'Virtual Swedish Air Force' },
  { value: 'vRNoAF', label: 'Virtual Royal Norwegian Air Force' },
  { value: 'vIAF', label: 'Virtual Israeli Air Force' },
];

// DEVELOPMENT
/*
export const LOGOUT_URL = 'http://localhost:5000/logout';
export const LOGIN_URL = 'http://localhost:5000/auth/vatsim';
export const PROFILE_URL = 'http://localhost:5000/profile';
export const LOCATION_URL = 'http://localhost:5000/api/saveLocation';

export const RESERVATION_UPDATE_URL = 'http://localhost:5000/data/updateReservation'
export const RESERVATION_ACTIVATE_URL = 'http://localhost:5000/data/activateReservation'
export const RESERVATION_CREATE_URL = 'http://localhost:5000/data/createReservation'
export const RESERVATION_CANCEL_URL = 'http://localhost:5000/data/cancelReservation'
export const UPDATE_LOCATION_URL = 'http://localhost:5000/api/saveLocation'

export const RESERVATIONS_URL = 'http://localhost:5000/data/reservations/';
export const DATA_URL = 'http://localhost:5000/data/';
*/

// PRODUCTION

export const LOGOUT_URL = 'https://lara-backend.lusep.fi/logout';
export const LOGIN_URL = 'https://lara-backend.lusep.fi/auth/vatsim';
export const PROFILE_URL = 'https://lara-backend.lusep.fi/profile';
export const LOCATION_URL = 'https://lara-backend.lusep.fi/api/saveLocation';

export const RESERVATION_UPDATE_URL = 'https://lara-backend.lusep.fi/data/updateReservation'
export const RESERVATION_CANCEL_URL = 'https://lara-backend.lusep.fi/data/cancelReservation'
export const RESERVATION_ACTIVATE_URL = 'https://lara-backend.lusep.fi/data/activateReservation'
export const RESERVATION_CREATE_URL = 'https://lara-backend.lusep.fi/data/createReservation'
export const UPDATE_LOCATION_URL = 'https://lara-backend.lusep.fi/api/saveLocation'

export const RESERVATIONS_URL = 'https://lara-backend.lusep.fi/data/reservations/';
export const DATA_URL = 'https://lara-backend.lusep.fi/data/';
